export default __webpack_public_path__ + "static/media/gallery_00.5be67a5e.jpg";